module.exports = __webpack_public_path__ + "media/dashboard/assets/tutorials/guiamain-04681991889b93d860afb2c4ac0ab2ff.gif";